// Redux & Action
import { useSelector } from 'react-redux';

// Auth & JWT
import { isUserLoggedIn, getToken } from "@core/auth/utils";

// Component
import { Grid } from '@mui/material';
import ImageShow from "views/components/ImageShow";

export default function MenuList({ dataList, selectPageHome }) {
    const dataMenu = useSelector(state => state.reduxHome.menu);
    const dataCampList = useSelector(state => state.reduxCamp.result);

    const genareateUrl = () => {
        if (dataCampList !== null) {
            let item = dataCampList.find((element) => element.category === 6);
            let mode = "demo";

            if (isUserLoggedIn()) {
                mode = "real";
            }

            if (item !== undefined && item !== null) {
                let urlOpenGame = "";

                if (item?.is_html) {
                    urlOpenGame = `${window.location.origin}/open-game/html?mode=${mode}&camp=${item?.camp.toLowerCase()}&code=${(item?.game_code === undefined || item?.game_code === null) ? item.code : item?.game_code}`;
                }
                else {
                    urlOpenGame = `${process.env.REACT_APP_API_URL}/general/generate/open-game/${mode}/${(item?.game_code === undefined || item?.game_code === null) ? item.code : item?.game_code}?url=${window.location.origin}&token=${getToken()}`;
                }

                return urlOpenGame;
            }
        }
    };

    return (
        <Grid container spacing={1} columns={{ xs: 8, md: 16 }}>
            {
                dataList.map((item) => (
                    <Grid key={item.id} item xs={2} md={2}>
                        {/* {
                            item.game_camp_type === 13 ?
                                <a href={genareateUrl()} target="_blank" style={{ textDecoration: "unset" }} rel="noreferrer">
                                    <div className={["menuList cursorPointer center", dataMenu.id === item.id ? "menuListActive" : ""].join(" ")}>
                                        <Grid container spacing={0.5} alignItems="center">
                                            <Grid item xs={12} md={5}>
                                                <ImageShow className="menuImage" src={item.image} alt="เมนูค่ายเกม" />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <div className="menuText textBoldHight">
                                                    {
                                                        item.name
                                                    }
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                </a>
                                :
                                <div className={["menuList cursorPointer center", dataMenu.id === item.id ? "menuListActive" : ""].join(" ")} onClick={() => selectPageHome(item)}>
                                    <Grid container spacing={0.5} alignItems="center">
                                        <Grid item xs={12} md={5}>
                                            <ImageShow className="menuImage" src={item.image} alt="เมนูค่ายเกม" />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <div className="menuText textBoldHight">
                                                {
                                                    item.name
                                                }
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                        } */}
                        <div className={["menuList cursorPointer center", dataMenu.id === item.id ? "menuListActive" : ""].join(" ")} onClick={() => selectPageHome(item)}>
                            <Grid container spacing={0.5} alignItems="center">
                                <Grid item xs={12} md={5}>
                                    <ImageShow className="menuImage" src={item.image} alt="เมนูค่ายเกม" />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div className="menuText textBoldHight">
                                        {
                                            item.name
                                        }
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                ))
            }
        </Grid>
    );
}